const Constants = {
    ID_SPLIT_FLAG: "__ID_SPLIT__",
    QUILL_UPLOAD_HOLDER_CLASS_NAME: "ql-attachment",
    blots: {
        attachment: "attachment",
    },
};

export default Constants;
